import React from "react";
import SurveyExpirationPage from "../Components/SurveyExpirationPage";
function SurveyExpirationPageContainer() {
  return <SurveyExpirationPage />;
}
export default SurveyExpirationPageContainer;
